import axios from "axios";
import { create } from "zustand";
import { appConfig } from "../../AppConfig";
import type { InputValuesType } from "../types/shared/inputValues";
import { ValueLabelStringType } from "../../utils/types/shared/miscellaneous";

interface InputValuesInterface {
  inputValues: InputValuesType | null;
  inputValuesLoading: boolean;
  loadInputValues: () => Promise<void>;
  setInputValues: (value: InputValuesType | null) => void;
  mapInputValuesToOptions: (
    itemName: keyof InputValuesType,
    labelKey?: string,
    valueKey?: string
  ) => ValueLabelStringType[];
}

export const useInputValuesStore = create<InputValuesInterface>((set, get) => ({
  inputValues: null,
  inputValuesLoading: false,
  setInputValues: (value: InputValuesType | null) =>
    set({ inputValues: value }),
  loadInputValues: async () => {
    const { inputValues, inputValuesLoading } = get();

    if (inputValues || inputValuesLoading) {
      return;
    }

    set({ inputValuesLoading: true });

    try {
      const { data } = await axios.get(`${appConfig.ApiBaseUrl()}/lists`);
      /* 
      if (error) {
        handleErrorResponse(error);
        set({ fieldsLoading: false });
        return;
      } 
      */

      set({ inputValues: data, inputValuesLoading: false });
    } catch (error) {
      console.error("Error loading data:", error);
      set({ inputValuesLoading: false });
    }
  },
  
  mapInputValuesToOptions: (itemName, labelKey = "name", valueKey = "id") => {
    const { inputValues, inputValuesLoading } = get();
    if (!inputValues?.[itemName] || inputValuesLoading) return [];

    return inputValues?.[itemName].map((item: any) => ({
      label: item[labelKey],
      value: item[valueKey],
    }));
  },
}));
